import { useState, useContext, useEffect } from 'react';
import {
    Box,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Snackbar,
    Alert,
    Menu,
    MenuItem,
    Chip,
    Divider,
    Avatar
} from '@mui/material';
import {
    Menu as MenuIcon,
    ChevronLeft as ChevronLeftIcon,
} from '@mui/icons-material';
import { Routes, Route } from 'react-router';
import Sidebar from '../components/Sidebar';
import Footer from '../../shared/components/Footer';

import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
const drawerWidth = 240;
import { useTheme } from '@mui/material/styles';
import { ThemeContext } from '../../context/themeContext';
import CatalogRouter from '../catalogo/router';
import BoxSildebar from '../../shared/components/BoxSildebar';
import { UtilesContext } from '../../shared/context/utilesContext';
import RrhhRouter from '../catalogo/rrhh/router';
import InsumoRouter from '../catalogo/insumo/router';
import TaskRouter from '../task/router';
import { CanAuth } from '../../shared/components/CanAuth';
import DashView from '../dashboard/views/dashView';
import { useAuth } from '../../shared/context/authContext';

import LogoutIcon from '@mui/icons-material/Logout';
import EmailIcon from '@mui/icons-material/Email';
import WorkIcon from '@mui/icons-material/Work';
import BadgeIcon from '@mui/icons-material/Badge';

import sigmalogo from '../../assets/sigmalogo.png'
import logoCCetemin from '../../assets/logo-c-con-flecha.png'

import Notifications from '../components/Notifications';


// Hook personalizado para persistir el estado en localStorage
const useLocalStorage = (key, initialValue) => {
    // Estado para almacenar nuestro valor
    const [storedValue, setStoredValue] = useState(() => {
        try {
            // Obtener de localStorage por key
            const item = window.localStorage.getItem(key);
            // Analizar JSON almacenado o devolver initialValue
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // Si hay error devolvemos initialValue
            console.error(error);
            return initialValue;
        }
    });

    // Return una versión envuelta de la función setter de useState que persiste el nuevo valor a localStorage
    const setValue = (value) => {
        try {
            // Permitir que value sea una función
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            // Guardar estado
            setStoredValue(valueToStore);
            // Guardar a localStorage
            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            console.error(error);
        }
    };

    return [storedValue, setValue];
};

export default function Layout() {
    // Usar localStorage para el estado del drawer
    const [open, setOpen] = useLocalStorage('drawerOpen', true);

    const {toggleTheme} = useContext(ThemeContext);

    const {alertSnackbar, setAlertSnackbar, getFirstNameAndLastName} = useContext(UtilesContext)

    const {authUser, logout, loadingLogout} = useAuth()
    const handleDrawerToggle = () => {
        setOpen(!open);
    };

    const theme = useTheme();

    const [anchorEl, setAnchorEl] = useState(null);

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh' }}>
            <AppBar 
                position="fixed" 
                sx={{ 
                    //zIndex: (theme) => theme.zIndex.drawer + 1,
                    backgroundColor: theme.palette.mode === 'dark' 
                        ? 'rgba(30, 30, 35, 0.8)' 
                        : 'rgba(255, 255, 255, 0.85)',
                    backdropFilter: 'blur(8px)',
                    color: theme.palette.text.primary,
                    boxShadow: theme.palette.mode === 'dark' 
                        ? '0 4px 20px 0 rgba(0, 0, 0, 0.25)' 
                        : '0 4px 20px 0 rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease-in-out',
                    borderRadius: 0
                }}
            >
                <Toolbar sx={{
                    justifyContent: 'space-between',
                    minHeight: '64px',
                    padding: '0 16px',
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                    }}>
                    <IconButton
                        color="inherit"
                        aria-label="toggle drawer"
                        onClick={handleDrawerToggle}
                        edge="start"
                        sx={{ 
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            },
                            "&.MuiIconButton-root": {
                                fontSize: '18px',
                                color: theme.palette.text.primary,
                            }
                         }}
                    >
                        {open ?  <ChevronLeftIcon /> :  <MenuIcon />}
                    </IconButton>
                    <Typography 
                        variant="h6" 
                        component="div" 
                        className='logoFont'
                        sx={{ 
                            color: theme.palette.text.primary,
                            fontWeight: 600,
                            letterSpacing: '0.5px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}
                    >
                        <img 
                            src={logoCCetemin} 
                            alt="logoCCetemin" 
                            style={{ 
                                width: '50px', 
                                height: '50px',
                                filter: theme.palette.mode === 'dark' ? 'invert(1) brightness(1) grayscale(1) contrast(0) saturate(0)' : 'none'
                            }} 
                        />
                        {/*<Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.2rem' }, fontWeight: 600, letterSpacing: '0.5px' }}>MantTrack</Typography>*/}
                        <Typography variant="h6" sx={{ fontSize: { xs: '1rem', md: '1.2rem' }, fontWeight: 600, letterSpacing: '0.5px' }}>SIGMA</Typography>
                    </Typography>

                    </Box>

                    
                    <Box sx={{ display: 'flex', alignItems: 'center', }}>
                    {/* <Notifications /> */}
                    <IconButton
                        color="inherit"
                        aria-label="toggle theme"
                        onClick={toggleTheme}
                        edge="start"
                        sx={{ 
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            },
                            "&.MuiIconButton-root": {
                                fontSize: '18px',
                                color: theme.palette.text.primary,
                            }
                         }}
                    >
                        {theme.palette.mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
                    </IconButton>
                    <Box sx={{ ml: 1, display: 'flex', alignItems: 'center' }}>
                        <Box 
                            onClick={(event) => setAnchorEl(event.currentTarget)}
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                cursor: 'pointer',
                                '&:hover': {
                                    opacity: 0.8
                                }
                            }}
                        >
                            <IconButton
                                sx={{
                                    ml: 1,
                                    borderRadius: '12px',
                                    padding: '8px',
                                    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                                    transition: 'all 0.2s',
                                    "&:hover": {
                                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                        transform: 'translateY(-2px)'
                                    }
                                }}
                            >
                                {authUser?.avatar ? (
                                    <Box
                                        component="img"
                                        src={authUser.avatar}
                                        alt={getFirstNameAndLastName(authUser?.fullName)}
                                        sx={{ width: 32, height: 32, borderRadius: '50%' }}
                                    />
                                ) : (
                                    <Box
                                        sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: '50%',
                                            backgroundColor: theme.palette.primary.main,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: theme.palette.primary.contrastText,
                                            fontWeight: 'bold',
                                            fontSize: '14px'
                                        }}
                                    >
                                        {getFirstNameAndLastName(authUser?.fullName)?.charAt(0) || 'U'}
                                    </Box>
                                )}
                            </IconButton>
                            
                            <Box sx={{ display: { xs: 'none', sm: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }, ml: 1 }}>
                                <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: '1' }}>
                                    {getFirstNameAndLastName(authUser?.fullName) || 'Usuario'}
                                </Typography>
                                <Typography variant="caption" color="text.secondary" sx={{ lineHeight: '1.2', fontSize: '11px', textTransform: 'capitalize', maxWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                    {authUser ? (authUser.position).toLowerCase() : 'Sin cargo'}
                                </Typography>
                            </Box>
                        </Box>
                        
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={() => setAnchorEl(null)}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    mt: 1.5,
                                    overflow: 'visible',
                                    filter: 'drop-shadow(0px 8px 24px rgba(0,0,0,0.15))',
                                    borderRadius: '24px',
                                    minWidth: 320,
                                    background: theme.palette.mode === 'dark' 
                                        ? 'linear-gradient(145deg, rgba(40,40,45,0.9), rgba(30,30,35,0.9))'
                                        : 'linear-gradient(145deg, rgba(255,255,255,0.9), rgba(245,245,245,0.9))',
                                    backdropFilter: 'blur(10px)',
                                    border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                                    '&:before': {
                                        content: '""',
                                        display: 'block',
                                        position: 'absolute',
                                        top: 0,
                                        right: 20,
                                        width: 12,
                                        height: 12,
                                        background: 'inherit',
                                        transform: 'translateY(-50%) rotate(45deg)',
                                        zIndex: 0,
                                        borderLeft: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                                        borderTop: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                                    },
                                }
                            }}
                            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                        >
                            <Box sx={{ p: 3 }}>
                                <Box sx={{ 
                                    position: 'relative',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: -24,
                                        left: -24,
                                        right: -24,
                                        height: 140,
                                        background: `linear-gradient(135deg, ${theme.palette.primary.main}20, ${theme.palette.secondary.main}30)`,
                                        borderRadius: '24px 24px 60% 60%',
                                        zIndex: 0
                                    }
                                }}>
                                    <Box sx={{ 
                                        position: 'relative',
                                        zIndex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        textAlign: 'center',
                                        mb: 3,
                                        mt: -1,
                                    }}>
                                        {authUser?.avatar ? (
                                            <Avatar
                                                src={authUser.avatar}
                                                alt={getFirstNameAndLastName(authUser?.fullName)}
                                                sx={{ 
                                                    width: 90, 
                                                    height: 90,
                                                    border: '4px solid',
                                                    borderColor: theme.palette.background.paper,
                                                    boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
                                                    mb: 2
                                                }}
                                            />
                                        ) : (
                                            <Avatar
                                                sx={{
                                                    width: 90,
                                                    height: 90,
                                                    mb: 2,
                                                    background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                                                    border: '4px solid',
                                                    borderColor: theme.palette.background.paper,
                                                    boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
                                                    fontSize: '2.25rem',
                                                    fontWeight: 600
                                                }}
                                            >
                                                {getFirstNameAndLastName(authUser?.fullName)?.charAt(0) || 'U'}
                                            </Avatar>
                                        )}
                                        <Typography variant="h6" sx={{ 
                                            fontWeight: 700,
                                            letterSpacing: '0.5px',
                                            mb: 0.5,
                                            mt: 2
                                        }}>
                                            {getFirstNameAndLastName(authUser?.fullName)}
                                        </Typography>
                                        <Box sx={{ 
                                            display: 'inline-flex', 
                                            alignItems: 'center', 
                                            background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
                                            borderRadius: '20px',
                                            padding: '4px 12px',
                                        }}>
                                            <WorkIcon sx={{ 
                                                fontSize: 16, 
                                                color: theme.palette.primary.main,
                                                mr: 0.5
                                            }} />
                                            <Typography 
                                                variant="body2" 
                                                sx={{ 
                                                    color: theme.palette.mode === 'dark' ? 'grey.300' : 'grey.800',
                                                    fontWeight: 500,
                                                    textTransform: 'capitalize'
                                                }}
                                            >
                                                {authUser?.position?.toLowerCase() || 'Sin cargo'}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box sx={{ 
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 2
                                    }}>
                                        <Box sx={{ 
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                                            borderRadius: '16px',
                                            p: 2,
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
                                            }
                                        }}>
                                            <Box sx={{
                                                minWidth: 40,
                                                height: 40,
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : theme.palette.primary.light + '20',
                                            }}>
                                                <EmailIcon sx={{ 
                                                    fontSize: 20,
                                                    color: theme.palette.primary.main
                                                }} />
                                            </Box>
                                            <Box>
                                                <Typography variant="caption" sx={{ 
                                                    color: 'text.secondary',
                                                    display: 'block',
                                                    mb: 0.5
                                                }}>
                                                    Correo electrónico
                                                </Typography>
                                                <Typography variant="body2" sx={{ 
                                                    fontWeight: 500,
                                                    color: theme.palette.mode === 'dark' ? 'grey.300' : 'grey.900'
                                                }}>
                                                    {authUser?.email || 'Sin email'}
                                                </Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ 
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1.5,
                                            background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                                            borderRadius: '16px',
                                            p: 2,
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)',
                                            }
                                        }}>
                                            <Box sx={{
                                                minWidth: 40,
                                                height: 40,
                                                borderRadius: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.1)' : theme.palette.primary.light + '20',
                                            }}>
                                                <BadgeIcon sx={{ 
                                                    fontSize: 20,
                                                    color: theme.palette.primary.main
                                                }} />
                                            </Box>
                                            <Box>
                                                <Typography variant="caption" sx={{ 
                                                    color: 'text.secondary',
                                                    display: 'block',
                                                    mb: 0.5
                                                }}>
                                                    Rol del sistema
                                                </Typography>
                                                <Typography variant="body2" sx={{ 
                                                    fontWeight: 500,
                                                    color: theme.palette.mode === 'dark' ? 'grey.300' : 'grey.900'
                                                }}>
                                                    {authUser?.role?.name || 'Sin rol'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box sx={{ mt: 2 }}>
                                    <MenuItem 
                                        onClick={() => {
                                            setAnchorEl(null);
                                            logout();
                                        }}
                                        sx={{
                                            borderRadius: '16px',
                                            p: 1.5,
                                            color: theme.palette.error.main,
                                            background: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                background: theme.palette.error.main,
                                                color: 'white',
                                            }
                                        }}
                                    >
                                        <LogoutIcon fontSize="small" sx={{ mr: 1.5 }} />
                                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                            Cerrar sesión
                                        </Typography>
                                    </MenuItem>
                                </Box>
                            </Box>
                        </Menu>
                    </Box>

                    </Box>
                </Toolbar>
            </AppBar>

            <Sidebar 
                open={open}
                onClose={handleDrawerToggle}
                drawerWidth={drawerWidth}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    width: "100%",
                    marginTop: '50px',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: theme => theme.transitions.create(['width', 'margin'], {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.enteringScreen,
                    }),
                }}
            >
                <Box sx={{
                    flexGrow: 1,
                    py: 3,
                    px: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <Routes>
                        <Route path="/" element={<CanAuth><DashView /></CanAuth>} />
                        <Route path="/activos/*" element={<CanAuth><CatalogRouter /></CanAuth>} />
                        <Route path="/rrhh/*" element={<CanAuth><RrhhRouter /></CanAuth>} />
                        <Route path="/insumos/*" element={<CanAuth><InsumoRouter /></CanAuth>} />
                        <Route path="/task/*" element={<CanAuth><TaskRouter /></CanAuth>} />
                    </Routes>
                </Box>

                <Footer />
            </Box>

            <BoxSildebar />

            <Snackbar
                open={alertSnackbar.open}
                autoHideDuration={6000}
                onClose={() => setAlertSnackbar({...alertSnackbar, open: false})}
                message={alertSnackbar.message}
                sx={{ zIndex: 9999999 }}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    severity={alertSnackbar.severity} 
                    sx={{ zIndex: 9999999 }} 
                    variant="filled"
                    onClose={() => setAlertSnackbar({...alertSnackbar, open: false})}
                >
                    {alertSnackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}